import "./logo-uploader.styl"
import logoUploaderTemplateFn from "./logo-uploader.pug"
import { resolveAttachmentUrl, uploadAttachment } from "@/lib/utils/attachment-url-resolver"
import { Color } from "@/lib/utils/color"
import { Notification, Icons, notificationManagerInstance as notificationManager } from "@/lib/managers/notification-manager"
import ko from "knockout"

export class LogoUploader

   constructor: (params) ->
      assertArgs(arguments, Object)
      assertOfType(params.logo, Function)
      assertOfType(params.callback, optional(Function))
      assertOfType(params.disableEdit, optional([Boolean, Function]))

      @color = params.color
      @hasDarkText = ko.pureComputed () =>
         return !Color.colorIsDark(@color())
      @logo = params.logo # This stores the attachment ID or legacy URL for saving
      @logoDisplayUrl = ko.observable('') # This stores the signed URL for display
      @attachmentId = ko.observable(null) # Store attachment ID separately
      @validationMessage = params.validationMessage
      @callback = if params.callback? then params.callback else () ->
      @showLoading = ko.observable(false)
      @disableEdit = if ko.isObservable(params.disableEdit) then params.disableEdit else ko.unwrap(params.disableEdit || false)

      @disposablePhotoBlock = false
      
      # Load initial logo if it's an attachment ID
      @loadInitialLogo()

      @newFile = ko.observable()
      @newFile.subscribe (newVal) =>
         return unless newVal?

         try
            @showLoading(true)
            @disposablePhotoBlock = true
            
            # Get file info
            file = newVal
            { name, size, type } = file
            
            # Check file type
            validTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/bmp', 'image/svg+xml']
            if not validTypes.includes(type)
               return notificationManager.show(
                  new Notification({
                     icon: Icons.WARNING,
                     text: "Invalid file type. Please upload an image.",
                  })
               )
            
            # Upload to S3 and get signed URL
            result = await uploadAttachment(file)
            
            # Store attachment ID for saving
            @attachmentId(result.attachmentId)
            @logo(result.attachmentId)
            # Set display URL
            @logoDisplayUrl(result.signedUrl)
         catch err
            console.error("Logo upload error:", err)
            notificationManager.show(
               new Notification({
                  icon: Icons.WARNING,
                  text: "Logo failed to upload. Please try again.",
               })
            )
         finally
            @showLoading(false)
   
   loadInitialLogo: =>
      # Load the logo - resolve attachment ID or filename to signed URL
      initialLogo = @logo()
      return unless initialLogo
      
      # Resolve and track the ID
      @attachmentId(initialLogo)
      resolveAttachmentUrl(initialLogo)
         .then (result) => @logoDisplayUrl(result.url) if result.url
         .catch (error) => console.error("Failed to load company logo:", error)

ko.components.register("logo-uploader",
   viewModel: LogoUploader,
   template: logoUploaderTemplateFn(),
)
